export const breadcrumb = {
  title: 'Panggilan',
  trunk: {
    index: 'SIP trunks'
  }
};
